import { defineComponent as j, ref as F, computed as b, onMounted as y, onUnmounted as k, h as L, Fragment as x, watchEffect as I, watch as B } from "vue";
import { useEventListener as R } from "./index348.js";
import { useTabDirection as C, Direction as h } from "./index355.js";
import { Hidden as D, Features as $ } from "./index332.js";
import { history as A } from "./index336.js";
import { dom as c } from "./index339.js";
import { focusElement as T, focusIn as g, Focus as p, FocusResult as W } from "./index340.js";
import { match as H } from "./index342.js";
import { microTask as M } from "./index356.js";
import { getOwnerDocument as q } from "./index343.js";
import { render as z } from "./index345.js";
function N(e) {
  if (!e) return /* @__PURE__ */ new Set();
  if (typeof e == "function") return new Set(e());
  let t = /* @__PURE__ */ new Set();
  for (let n of e.value) {
    let a = c(n);
    a instanceof HTMLElement && t.add(a);
  }
  return t;
}
var S = ((e) => (e[e.None = 1] = "None", e[e.InitialFocus = 2] = "InitialFocus", e[e.TabLock = 4] = "TabLock", e[e.FocusLock = 8] = "FocusLock", e[e.RestoreFocus = 16] = "RestoreFocus", e[e.All = 30] = "All", e))(S || {});
let le = Object.assign(j({ name: "FocusTrap", props: { as: { type: [Object, String], default: "div" }, initialFocus: { type: Object, default: null }, features: { type: Number, default: 30 }, containers: { type: [Object, Function], default: F(/* @__PURE__ */ new Set()) } }, inheritAttrs: !1, setup(e, { attrs: t, slots: n, expose: a }) {
  let o = F(null);
  a({ el: o, $el: o });
  let s = b(() => q(o)), u = F(!1);
  y(() => u.value = !0), k(() => u.value = !1), J({ ownerDocument: s }, b(() => u.value && !!(e.features & 16)));
  let d = K({ ownerDocument: s, container: o, initialFocus: b(() => e.initialFocus) }, b(() => u.value && !!(e.features & 2)));
  Q({ ownerDocument: s, container: o, containers: e.containers, previousActiveElement: d }, b(() => u.value && !!(e.features & 8)));
  let i = C();
  function r(l) {
    let m = c(o);
    m && ((v) => v())(() => {
      H(i.value, { [h.Forwards]: () => {
        g(m, p.First, { skipElements: [l.relatedTarget] });
      }, [h.Backwards]: () => {
        g(m, p.Last, { skipElements: [l.relatedTarget] });
      } });
    });
  }
  let f = F(!1);
  function w(l) {
    l.key === "Tab" && (f.value = !0, requestAnimationFrame(() => {
      f.value = !1;
    }));
  }
  function E(l) {
    if (!u.value) return;
    let m = N(e.containers);
    c(o) instanceof HTMLElement && m.add(c(o));
    let v = l.relatedTarget;
    v instanceof HTMLElement && v.dataset.headlessuiFocusGuard !== "true" && (O(m, v) || (f.value ? g(c(o), H(i.value, { [h.Forwards]: () => p.Next, [h.Backwards]: () => p.Previous }) | p.WrapAround, { relativeTo: l.target }) : l.target instanceof HTMLElement && T(l.target)));
  }
  return () => {
    let l = {}, m = { ref: o, onKeydown: w, onFocusout: E }, { features: v, initialFocus: U, containers: V, ...P } = e;
    return L(x, [!!(v & 4) && L(D, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: r, features: $.Focusable }), z({ ourProps: m, theirProps: { ...t, ...P }, slot: l, attrs: t, slots: n, name: "FocusTrap" }), !!(v & 4) && L(D, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: r, features: $.Focusable })]);
  };
} }), { features: S });
function G(e) {
  let t = F(A.slice());
  return B([e], ([n], [a]) => {
    a === !0 && n === !1 ? M(() => {
      t.value.splice(0);
    }) : a === !1 && n === !0 && (t.value = A.slice());
  }, { flush: "post" }), () => {
    var n;
    return (n = t.value.find((a) => a != null && a.isConnected)) != null ? n : null;
  };
}
function J({ ownerDocument: e }, t) {
  let n = G(t);
  y(() => {
    I(() => {
      var a, o;
      t.value || ((a = e.value) == null ? void 0 : a.activeElement) === ((o = e.value) == null ? void 0 : o.body) && T(n());
    }, { flush: "post" });
  }), k(() => {
    t.value && T(n());
  });
}
function K({ ownerDocument: e, container: t, initialFocus: n }, a) {
  let o = F(null), s = F(!1);
  return y(() => s.value = !0), k(() => s.value = !1), y(() => {
    B([t, n, a], (u, d) => {
      if (u.every((r, f) => d?.[f] === r) || !a.value) return;
      let i = c(t);
      i && M(() => {
        var r, f;
        if (!s.value) return;
        let w = c(n), E = (r = e.value) == null ? void 0 : r.activeElement;
        if (w) {
          if (w === E) {
            o.value = E;
            return;
          }
        } else if (i.contains(E)) {
          o.value = E;
          return;
        }
        w ? T(w) : g(i, p.First | p.NoScroll) === W.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), o.value = (f = e.value) == null ? void 0 : f.activeElement;
      });
    }, { immediate: !0, flush: "post" });
  }), o;
}
function Q({ ownerDocument: e, container: t, containers: n, previousActiveElement: a }, o) {
  var s;
  R((s = e.value) == null ? void 0 : s.defaultView, "focus", (u) => {
    if (!o.value) return;
    let d = N(n);
    c(t) instanceof HTMLElement && d.add(c(t));
    let i = a.value;
    if (!i) return;
    let r = u.target;
    r && r instanceof HTMLElement ? O(d, r) ? (a.value = r, T(r)) : (u.preventDefault(), u.stopPropagation(), T(i)) : T(a.value);
  }, !0);
}
function O(e, t) {
  for (let n of e) if (n.contains(t)) return !0;
  return !1;
}
export {
  le as FocusTrap
};
